import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class CareerRoutesCard extends BaseModel {
  static override constructorName = 'CareerRoutesCard'

  'career_direction': string = ''
  description: string = ''
  id: number = 0
  name: string = ''
  slug: string = ''
  'card_image': string = ''
  selected: boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.card_image = toCroppedImage(data.card_image)
    }
  }
}

registerModel(CareerRoutesCard)
